import {
  CardErrorType,
  GENERIC_SENDER_EMAIL,
  SenderId,
} from "./types/apiTypes.ts";

export const CARD_ERROR_SEVERITIES = {
  contactDetailsInconsistent: "error",
  duplicateEmail: "error",
  missingSenderManualDispatch: "error",
  missingSenderAutomaticDispatch: "warning",
  emailSenderManualDispatch: "error",
  xmasSenderAutomaticDispatch: "warning",
  senderUnknown: "error",
  senderNotSigner: "warning",
  duplicateName: "warning",
} as const satisfies Record<CardErrorType, "error" | "warning">;

export const senderCardStatuses = ({
  senderId,
  senderUnknown,
  manualDispatch,
  signatureUidNumbers,
}: {
  senderId: SenderId | undefined;
  senderUnknown: boolean;
  manualDispatch: boolean;
  signatureUidNumbers: number[] | undefined;
}): CardErrorType[] => {
  const statuses: CardErrorType[] = [];
  if (!senderId) {
    statuses.push(
      manualDispatch
        ? "missingSenderManualDispatch"
        : "missingSenderAutomaticDispatch",
    );
  }
  if (senderId?.type === "email" && manualDispatch) {
    statuses.push("emailSenderManualDispatch");
  }
  if (
    senderId?.type === "email" &&
    !manualDispatch &&
    senderId.email === GENERIC_SENDER_EMAIL
  ) {
    statuses.push("xmasSenderAutomaticDispatch");
  }
  if (senderId?.type === "employee" && senderUnknown) {
    statuses.push("senderUnknown");
  } else if (
    signatureUidNumbers !== undefined &&
    senderId?.type === "employee" &&
    !signatureUidNumbers.includes(senderId.uidNumber)
  ) {
    statuses.push("senderNotSigner");
  }
  return statuses;
};
